import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Checkbox } from 'antd';
import classnames from 'classnames';
import TabeeAuth from '../../../tabee-auth';
import { strings, ui } from '../../../tools';
const PasswordForm = ({
  withRemember,
  errorMessage,
  translator,
  i18nPrefix,
  inputClassName,
  onResult
}) => {
  const t = translator,
    prefix = i18nPrefix ? `${i18nPrefix}.` : '',
    rememberKey = 'tabee-go-remember',
    [username, $username] = useState(''),
    [password, $password] = useState(''),
    [remember, $remember] = useState(localStorage.getItem(rememberKey) === 'true'),
    [locked, $locked] = useState(false),
    [message, $message] = useState(''),
    next = () => document.querySelector('input[type="password"]').focus(),
    handleLogin = () => {
      if (locked || !username || !password) return;
      $locked(true);
      $message('');
      TabeeAuth.signIn({
        username,
        password
      }).then(onResult).catch(onResult);
    };
  useEffect(() => {
    localStorage.setItem(rememberKey, remember.toString());
  }, [remember]);
  useEffect(() => {
    $message(errorMessage);
    $locked(false);
  }, [errorMessage]);
  useEffect(() => {
    ui.focusFirstInput();
  }, []);
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Item, null, /*#__PURE__*/React.createElement(Input, {
    autoFocus: true,
    className: classnames('tabee-login__input', 'tabee_login__input-email', inputClassName),
    placeholder: t(`${prefix}username`),
    disabled: locked,
    value: username,
    onChange: e => $username(e.target.value),
    onPressEnter: next
  })), /*#__PURE__*/React.createElement(Form.Item, null, /*#__PURE__*/React.createElement(Input.Password, {
    type: "password",
    className: classnames('tabee-login__input', 'tabee_login__input-password', inputClassName),
    placeholder: t(`${prefix}password`),
    disabled: locked,
    value: password,
    onChange: e => $password(e.target.value),
    onPressEnter: handleLogin
  })), /*#__PURE__*/React.createElement(Form.Item, {
    className: "tabee-login__offset-wrap"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "tabee-login__submit",
    type: "primary",
    disabled: locked || !username || !password,
    onClick: handleLogin
  }, locked ? t(`${prefix}loginSigningIn`) : t(`${prefix}loginSignIn`))), withRemember && /*#__PURE__*/React.createElement(Form.Item, {
    className: "tabee-login__offset-wrap"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    className: classnames("tabee-login__checkbox", 'tabee-login__remember', inputClassName),
    checked: remember,
    disabled: locked,
    onChange: $remember
  }, t(`${prefix}keepSignIn`))), !!message && /*#__PURE__*/React.createElement("div", {
    className: "tabee-login__message"
  }, t(`errors.${strings.toKey((typeof message === 'string' ? message : 'networkError').split(',')[0])}`)));
};
export default PasswordForm;